// Dependencies
require("webstrap/type");

// Styles
require("./pricing.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/element/pricing/index.js
 ** module id = 101
 ** module chunks = 0 1
 **/